import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ShowsService } from '../services/shows.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { EditUserComponent } from './edit-user/edit-user.component'; 
import { format, parseISO, isValid } from 'date-fns';
@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrl: './user.component.scss',
    standalone: false
})
export class UserComponent implements AfterViewInit {
  website_id: number = -1;
  platforms: any = [];
  email_show: string = '';
  total_shows = 0;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['display_name', 'email_address', 'went_online_timestamp', 'location_tracking', 'action'];
  loading = false;
  total_reports = 0;
  originalData: any[] = [];
  toggleButton: boolean = false;
  editShowData: any
  currentPage = 1;
  pageSize = 50;
  currentSearchTerm: string = '';
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(public ShowsService: ShowsService, public dialog: MatDialog) {
    const staticPlatforms = [
      { id: 1, title: "On" },
      { id: 0, title: "Off" },
    ];
    for (let platform of staticPlatforms) {
      this.platforms.push({
        id: platform.id,
        title: platform.title,
      });
    }
  }
  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => {
      this.currentPage = 1;
      if (this.email_show.trim() !== '' || this.website_id !== -1) {
        this.onSubmitSearch(this.email_show);
      } else {
        this.getUserData(this.currentPage, this.pageSize);
      }
    });

  }
  ngOnInit(): void {
    this.getUserData();
  }
  openFieldEditorDialog(value: string, title: string) {
    this.toggleButton = true;
    const dialogRef = this.dialog.open(EditUserComponent, {
      id: 'field-editor',
      maxWidth: '600px',
      width: '100%',
      data: {
        title: title,
        value: value
      }
    });
    return dialogRef.afterClosed()
  }

  editShow(show: any) {
    this.openFieldEditorDialog(show, 'Edit Users');
  }
  toggleLocationTracking(element: any): void {
    console.log('element', element);
    element.location_tracking = element.location_tracking === 1 ? 0 : 1;
    this.ShowsService.UpdateUsers(element.UUID, element).subscribe({
      next: (response) => {
        console.log('successfully');
      },
    });
  }
  getUserData(page = this.currentPage, limit = this.pageSize) {
    this.currentSearchTerm = '';
    this.dataSource.data = [];
    this.loading = true;
    const sortField = this.sort?.active || 'went_online_timestamp';
    const sortDirection = this.sort?.direction || 'desc';
    this.ShowsService.getUserDataListing(page, limit, sortField, sortDirection).subscribe({
      next: (response) => {
        if (response.data) {
          this.originalData = response.data;
          this.dataSource = new MatTableDataSource(this.originalData);
          this.total_shows = response.total;
          this.loading = false;
        }
      }
    });
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.dataSource.data = [];
    const searchTerm = this.email_show.trim();
    if (searchTerm !== '') {
      this.getSearchOnly(searchTerm, this.currentPage, this.pageSize);
    } else {
      this.getUserData(this.currentPage, this.pageSize);
    }
  }
  getSearchOnly(search: string, page: number = this.currentPage, size: number = this.pageSize) {
    this.currentSearchTerm = search;
    if (search.trim() !== '') {
      this.dataSource.data = [];
      this.loading = true;
      const sortField = this.sort?.active || 'logged_in_date';
      const sortDirection = this.sort?.direction || 'desc';
      this.ShowsService.getSearchUserData(page, size, search, this.website_id, sortField, sortDirection).subscribe({
        next: (responces) => {
          console.log('responces', responces);
          if (responces.data) {
            this.dataSource.data = responces.data;
            this.total_shows = responces.total;
            this.loading = false;
          }
        }
      });
    } else {
      this.getUserData();
    }
  }

  getLocationTrackingOnly(locationId: number) {
    if (locationId !== -1) {
      this.dataSource.data = [];
      this.loading = true;
      console.log('Selected website_id', locationId);
      const sortField = this.sort?.active || 'logged_in_date';
      const sortDirection = this.sort?.direction || 'desc';
      this.ShowsService.getSearchUserData(this.currentPage, this.pageSize, '', this.website_id, sortField, sortDirection).subscribe({
        next: (items) => {
          console.log('Location-tracked items:', items);
          const filtered = items.data;
          this.dataSource.data = filtered;
          this.total_shows = items.total;
          console.log('this.total_shows', this.total_shows);

          this.loading = false;
        }
      })
    } else {
      this.getUserData();
    }
  }
  onSubmitSearch(searchValue: string) {
    if (this.paginator) {
      this.paginator.firstPage();
    }

    if (searchValue.trim() !== '' && this.website_id !== -1) {
      this.loading = true;
      const sortField = this.sort?.active || 'logged_in_date';
      const sortDirection = this.sort?.direction || 'desc';
      this.ShowsService.getSearchUserData(this.currentPage, this.pageSize, searchValue, this.website_id, sortField, sortDirection).subscribe({
        next: (item) => {
          let filtered = item.data;
          filtered = filtered.filter((item: any) => Number(item.location_tracking) === this.website_id);
          this.dataSource.data = filtered;
          this.total_shows = item.total;
          this.loading = false;
        }
      })
    } else if (searchValue.trim() !== '') {
      this.getSearchOnly(searchValue);
    } else if (this.website_id !== -1) {
      this.getLocationTrackingOnly(this.website_id);
    } else {
      this.getUserData();
    }
  }
  getFormattedDate(dateString: string): string {
  
    // Convert "2026-07-29 14:17:06 +00:00" => "2026-07-29T14:17:06"
    let normalized = dateString.split(' ')[0] + 'T' + dateString.split(' ')[1];
  
    let date = parseISO(normalized);
  
    if (!isValid(date)) {
      // Fallback to native Date
      date = new Date(normalized);
      if (isNaN(date.getTime())) return 'Invalid date';
    }
  
    const day = date.getDate();
    const suffix = this.getDaySuffix(day);
    const month = format(date, 'MMMM');
    const year = date.getFullYear();
  
    return `${month} ${day}${suffix}, ${year}`;
  }
  
    getDaySuffix(day: number): string {
      if (day >= 11 && day <= 13) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }

}

